import React from 'react';
import styles from '../Navbar.module.css';

const SacuvaniProfiliIkonica = (props) => (
 <svg className={styles.sadrzajMainDugmeIkonicaPopravak1} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_3719_17232)">
<path fillRule="evenodd" clipRule="evenodd" d="M26.9933 12.9134C26.9933 12.5554 26.7234 12.333 26.1853 12.2463L18.9468 11.1884L15.703 4.59387C15.5207 4.19811 15.2847 4 14.9964 4C14.7086 4 14.4722 4.19811 14.2903 4.59387L11.0451 11.1884L3.80715 12.2463C3.2695 12.333 3 12.5554 3 12.9134C3 13.1155 3.12022 13.3478 3.36022 13.6083L8.60894 18.7389L7.36916 25.9852C7.35039 26.1209 7.34056 26.2175 7.34056 26.2759C7.34056 26.478 7.39106 26.6501 7.49207 26.7898C7.59218 26.9304 7.74324 27 7.94525 27C8.11866 27 8.31129 26.9425 8.52268 26.8262L14.9964 23.4058L21.4702 26.8262C21.6726 26.9416 21.8653 27 22.0476 27C22.2407 27 22.3864 26.9304 22.4874 26.7898C22.5879 26.6501 22.6384 26.478 22.6384 26.2759C22.6384 26.1496 22.6335 26.053 22.6241 25.9852L21.3839 18.7389L26.6183 13.6083C26.8682 13.3572 26.9933 13.1254 26.9933 12.9134Z" fill="#1070D1"/>
</g>
<defs>
<clipPath id="clip0_3719_17232">
<rect width="24" height="28" fill="white" transform="translate(3 4)"/>
</clipPath>
</defs>
</svg>
);

export default SacuvaniProfiliIkonica;